import script from "./VolumeControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./VolumeControls.vue?vue&type=script&setup=true&lang=ts"

import "./VolumeControls.vue?vue&type=style&index=0&id=48b343b4&lang=scss"

const __exports__ = script;

export default __exports__